import { initialDiscountFormData } from 'containers/invoices/edit-invoice/invoicesEditSlice';
import AddDiscountSection from './AddDiscountSection';
import { FC, useState } from 'react';
import AddInvoiceDiscountModal, {
  IAddInvoiceDiscountModalConfig,
  addInvoiceDiscountModalConfigInitState
} from './AddInvoiceDiscountModal';
import { useAppDispatch } from 'hooks';
import { DiscountFormData } from 'containers/invoices/types';
import { VoidFn } from 'types/baseTypes';

export interface AddInvoiceDiscountWrapperProps {
  className?: string;
  isAddDiscountDisabled: boolean;
  // TODO use the same model in create and edit invoice for discount
  selectedDiscount?: DiscountFormData;
  isEditInvoiceFlow?: boolean;
  lineItemsTotalCost: number;
  handleRemoveDiscount: VoidFn;
  onSaveDiscount: (arg: DiscountFormData) => void;
  isFromBillingTab?: boolean;
}

const AddInvoiceDiscountWrapper: FC<AddInvoiceDiscountWrapperProps> = ({
  className = '',
  selectedDiscount = initialDiscountFormData,
  isEditInvoiceFlow = false,
  isAddDiscountDisabled = true,
  lineItemsTotalCost = 0,
  handleRemoveDiscount,
  onSaveDiscount,
  isFromBillingTab = false
}) => {
  const dispatch = useAppDispatch();
  const [addInvoiceDiscountModalConfig, setAddInvoiceDiscountModalConfig] = useState<IAddInvoiceDiscountModalConfig>(
    addInvoiceDiscountModalConfigInitState
  );

  const onAddDiscount = (): void => {
    const config: IAddInvoiceDiscountModalConfig = {
      title: 'Add a discount',
      open: true,
      shouldInitializeFields: false,
      data: {
        amount: '',
        percent: '',
        isDiscountAmountSelected: selectedDiscount?.isDiscountAmountSelected ?? false
      },
      editMode: false
    };

    setAddInvoiceDiscountModalConfig(config);
  };

  const onEditDiscount = (): void => {
    const config: IAddInvoiceDiscountModalConfig = {
      title: 'Edit discount',
      open: true,
      shouldInitializeFields: true,
      data: {
        amount: selectedDiscount?.discountInCurrency ?? '',
        percent: selectedDiscount?.discountPercent ?? '',
        isDiscountAmountSelected: selectedDiscount?.isDiscountAmountSelected ?? false
      },
      editMode: false
    };

    setAddInvoiceDiscountModalConfig(config);
  };

  const onRemoveDiscount = (): void => {
    handleRemoveDiscount();
  };

  const onCloseAddDiscountModal = (): void => {
    setAddInvoiceDiscountModalConfig(addInvoiceDiscountModalConfigInitState);
  };

  const onSaveDiscountClick = (discountData: DiscountFormData): void => {
    onSaveDiscount(discountData);
    onCloseAddDiscountModal();
  };

  return (
    <div className={`${className}`}>
      <AddDiscountSection
        isAddDiscountDisabled={isAddDiscountDisabled}
        isEditInvoiceFlow={isEditInvoiceFlow}
        onAddDiscountClick={!isAddDiscountDisabled ? onAddDiscount : null}
        onEditDiscount={!isAddDiscountDisabled && onEditDiscount}
        onClearSelectedDiscount={onRemoveDiscount}
        selectedDiscount={selectedDiscount}
        isFromBillingTab={isFromBillingTab}
        className={isFromBillingTab ? 'border-b-0 p-3' : ''}
      />
      {addInvoiceDiscountModalConfig.open && (
        <AddInvoiceDiscountModal
          config={addInvoiceDiscountModalConfig}
          lineItemsTotalCost={lineItemsTotalCost}
          onClose={onCloseAddDiscountModal}
          onModifyDiscountClick={onSaveDiscountClick}
          onSaveDiscountClick={onSaveDiscountClick}
        />
      )}
    </div>
  );
};

export default AddInvoiceDiscountWrapper;
